angular.module('Itao.IndicatorMap').controller('GridController', ['$scope', '$compile', 'GridItemConfig','mapConfig', function($scope, $compile, GridItemConfig, mapConfig) {
  'use strict';
  var gridstack = null;
  var defaultItem = {'x': '0', 'y': '0', 'width': '6', 'height': '1'};
  var defaultGridStackOptions = {
    cellHeight: 300,
    verticalMargin: 10,
    width: 6,
    handleClass: 'drag-handle-button',
    resizable: {
      handles: 'e, se, s, sw, w'
    }
  };

  /**
   * Adds a listener to create and append new griditems to the given container element
   * @param {jQuery} gridContainerElement container of gridstack
   */
  function registerAddListener(gridContainerElement) {
    $scope.$on('createNewWidget', function(event, data) {
      if(data.type === 'map' || data.type === 'lineChart') {
        defaultItem.height = '2';
      } else {
        defaultItem.height = '' + mapConfig.defaultGridWidgetHeight;
      }
      var gridItemConfiguration = angular.extend({}, defaultItem, data);
      var gridItemName = GridItemConfig.generateUniqueItemName();
      $scope.config.grids[gridItemName] = gridItemConfiguration;
      gridContainerElement.prepend(generateGridItemElement(gridItemName, 0));
    });
  }

  /**
   * Adds a listener to rerender the grid by the current config in the given container element
   * @param {jQuery} gridContainerElement container of gridstack
   */
  this.registerRenderListener = function(gridContainerElement) {
    var that = this;
    $scope.$on('renderGrid', function(event, data) {
      angular.forEach(gridContainerElement.children(), function(element) {
        that.removeItem(element);
      });

      angular.forEach($scope.config.grids, function(value) {
        that.removeFromCollection(value.propertyName);
      });

      $scope.config.grids = data.config.gridContainer.grids;
      renderGridFromConfig(gridContainerElement, $scope.config.grids);
    });
  };

  /**
   * Rerenders the grid by a given configuration in the container element
   * @param {jQuery} gridContainerElement container of gridstack
   * @param {Object} gridConfig Object with grid configuration
   */
  function renderGridFromConfig(gridContainerElement, gridConfig) {
    // Sort grid items for y and x, so no gaps will appear
    var sortedGridItems = GridItemConfig.sortGridConfigs(gridConfig);

    // create and append griditems as DOM elements
    angular.forEach(sortedGridItems, function(value) {
      gridContainerElement.append(generateGridItemElement(value.propertyName, 0));
    });
  }

  /**
   *
   * @param {String} gridItemName name of the griditem's property in scope.config
   * @param {Integer} autoPosition Indicates if item should auto-positioned
   * @returns {jQuery}
   */
  function generateGridItemElement(gridItemName, autoPosition) {
    return $compile('<grid-item class="grid-stack-item" grid-item-name="' + gridItemName+ '" config="config.grids.' + gridItemName + '" diagram-data="diagramData" data-gs-min-width="2" data-gs-max-width="6" data-gs-auto-position="' + autoPosition +'" select-district="selectDistrict(district)" deselect-district="deselectDistrict(district)"></grid-item>')($scope);
  }

  /**
   * Returns the gridstack height of a griditem jQuery DOM element
   * @param {jQuery} element element with gridstack attributes
   * @returns {Integer}
   */
  function getGridStackHeight(element) {
    return parseInt(element.attr('data-gs-height'));
  }

  /**
   * Initializes gridstack on a DOM element, appends griditems from configuration and set up listeners
   * @param {jQuery} gridContainerElement DOM element which should be the gridstack container
   * @param {Object} options Options to configure gridstack
   * @returns {*}
   */
  this.init = function(gridContainerElement, options) {
    var gridStackOptions = angular.extend({}, defaultGridStackOptions, options);

    // Initialize gridstack container
    gridstack = gridContainerElement.gridstack(gridStackOptions).data('gridstack');

    // Render grid from current config
    renderGridFromConfig(gridContainerElement, $scope.config.grids);

    // register listener for adding new events
    registerAddListener(gridContainerElement);
    // register listener for rerender from config
    this.registerRenderListener(gridContainerElement);

    return gridstack;
  };

  /**
   * Removes a grid item (as jQuery DOM element) from gridstack and the DOM
   * @param {jQuery} element element which should be removed
   * @returns {*}
   */
  this.removeItem = function(element) {
    if(gridstack) {
      return gridstack.removeWidget(element, true);
    }
    return null;
  };

  /**
   * Removes a griditem from the griditem configuration object by name
   * @param {String} gridItemName unique name of the griditem
   */
  this.removeFromCollection = function(gridItemName) {
    delete $scope.config.grids[gridItemName];
  };

  /**
   * Makes a DOM element inside a gridstack container to a real griditem
   * @param {jQuery} element DOM element inside a gridstack container
   * @returns {*}
   */
  this.makeWidget = function(element) {
    if(gridstack) {
      gridstack.makeWidget(element);
      return element;
    }
    return null;
  };

  /**
   * Decrements the height of a gridstack item
   * @param {jQuery} element DOM element inside a gridstack container
   */
  this.decreaseWidgetHeight = function(element) {
    var currentHeight = getGridStackHeight(element);
    if(currentHeight === 1) {
      return;
    }
    gridstack.resize(element, null, currentHeight - 1);
  };

  /**
   * Increments the height of a gridstack item
   * @param {jQuery} element DOM element inside a gridstack container
   */
  this.increaseWidgetHeight = function(element) {
    var currentHeight = getGridStackHeight(element);
    gridstack.resize(element, null, currentHeight + 1);
  };

}]);
